import "../../Stylesheet/Home.css"
import profile from "../../Assets/profile.png";
import { FiMail, FiDownload, FiArrowRight } from "react-icons/fi";
import HomeProject from "../Home/HomeProject"
import Skill from "../Home/Skill"
import Certification from "../Home/Certfication";
import Experience from "../Home/Experience";
import { useContext } from "react";
import { LanguageContext } from "../../Context/LanguageContext";
import { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";
// import { Link } from "react-router-dom";

export default function Home() {

  const { t, lang } = useContext(LanguageContext);
  const h = t.home;

  const [showArrow, setShowArrow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowArrow(true);
      } else {
        setShowArrow(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = '/New-updated.pdf';
    link.download = `${h.name}.pdf`;
    link.click();
  };

  return (
    <>
      <div>
        <div className="hero-wrapper">
          <div className="hero-container">

            {/* Text Content */}
            <div className="hero-content">
              <p className="hero-exp">{h.years}</p>
              <h1 className={lang === "ta" ? "heading-ta" : "heading-en"}>
                {/* {h.greeting} */}
                <span>{h.name}</span>
              </h1>
              <p className="hero-tvk">
                {h.desigination}
              </p>
              <p className={lang === "ta" ? "p-ta" : "p-en"}>
                {h.description}
              </p>

              {/* Buttons */}
              <div className="hero-actions">
                <button className="primary-btn">
                  {h.viewPortfolio}  <FiArrowRight />
                </button>

                <div className="btn-flex">
                  <button className="icon-btn" onClick={handleDownload}>
                    <FiDownload /> {h.resume}
                  </button>

                  <button className="icon-btn">
                    {/* <Link to="/contact"> */}
                    <FiMail />  {h.contact}
                    {/* </Link> */}
                  </button>
                </div>

              </div>
            </div>

            {/* Avatar */}
            <div className="avatar-box">
              <div className="avatar-ring">
                <img src={profile} alt="profile" />
                <span className="online-dot"></span>
              </div>

              <div className="badge" >
                {h.badge}
              </div>
            </div>

          </div>
        </div>
        <Skill />
        <HomeProject />
        <Experience />
        <Certification />
      </div>

      {showArrow && (
        <div className="scroll-top-arrow" onClick={scrollToTop}>
          <FaArrowUp />
        </div>
      )}

    </>
  )
}
